import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { BLEND_MODES } from '@pixi/constants';
var BLEND = 0;
var OFFSET = 1;
var CULLING = 2;
var DEPTH_TEST = 3;
var WINDING = 4;
var DEPTH_MASK = 5;
var State = /*#__PURE__*/function () {
  function State() {
    _classCallCheck(this, State);
    this.data = 0;
    this.blendMode = BLEND_MODES.NORMAL;
    this.polygonOffset = 0;
    this.blend = true;
    this.depthMask = true;
  }
  _createClass(State, [{
    key: "blend",
    get: function get() {
      return !!(this.data & 1 << BLEND);
    },
    set: function set(value) {
      if (!!(this.data & 1 << BLEND) !== value) {
        this.data ^= 1 << BLEND;
      }
    }
  }, {
    key: "offsets",
    get: function get() {
      return !!(this.data & 1 << OFFSET);
    },
    set: function set(value) {
      if (!!(this.data & 1 << OFFSET) !== value) {
        this.data ^= 1 << OFFSET;
      }
    }
  }, {
    key: "culling",
    get: function get() {
      return !!(this.data & 1 << CULLING);
    },
    set: function set(value) {
      if (!!(this.data & 1 << CULLING) !== value) {
        this.data ^= 1 << CULLING;
      }
    }
  }, {
    key: "depthTest",
    get: function get() {
      return !!(this.data & 1 << DEPTH_TEST);
    },
    set: function set(value) {
      if (!!(this.data & 1 << DEPTH_TEST) !== value) {
        this.data ^= 1 << DEPTH_TEST;
      }
    }
  }, {
    key: "depthMask",
    get: function get() {
      return !!(this.data & 1 << DEPTH_MASK);
    },
    set: function set(value) {
      if (!!(this.data & 1 << DEPTH_MASK) !== value) {
        this.data ^= 1 << DEPTH_MASK;
      }
    }
  }, {
    key: "clockwiseFrontFace",
    get: function get() {
      return !!(this.data & 1 << WINDING);
    },
    set: function set(value) {
      if (!!(this.data & 1 << WINDING) !== value) {
        this.data ^= 1 << WINDING;
      }
    }
  }, {
    key: "blendMode",
    get: function get() {
      return this._blendMode;
    },
    set: function set(value) {
      this.blend = value !== BLEND_MODES.NONE;
      this._blendMode = value;
    }
  }, {
    key: "polygonOffset",
    get: function get() {
      return this._polygonOffset;
    },
    set: function set(value) {
      this.offsets = !!value;
      this._polygonOffset = value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[@pixi/core:State blendMode=".concat(this.blendMode, " clockwiseFrontFace=").concat(this.clockwiseFrontFace, " culling=").concat(this.culling, " depthMask=").concat(this.depthMask, " polygonOffset=").concat(this.polygonOffset, "]");
    }
  }], [{
    key: "for2d",
    value: function for2d() {
      var state = new State();
      state.depthTest = false;
      state.blend = true;
      return state;
    }
  }]);
  return State;
}();
export { State };